import { useCallback } from "react";

import type { ImageDto } from "@/api/types";
import type { FormImage } from "@/components/ImageInput/useImageInput";
import { isImageUploaded } from "@/components/ImageInput/useImageInput";
import { fileMutations } from "@/queries/files/mutations";

export function useUploadImage(): {
  uploadImage: UploadImage;
  uploadFormImage: UploadFormImage;
  isUploadingImage: boolean;
} {
  const { mutateAsync: uploadImage, isPending: isUploadingImage } = fileMutations.useAddImage();

  const uploadFormImage: UploadFormImage = useCallback(
    async (formImage) => {
      if (isImageUploaded(formImage)) {
        return formImage;
      }

      if (formImage.uploadPromise) {
        return formImage.uploadPromise;
      }

      return await uploadImage(formImage);
    },
    [uploadImage],
  );

  return { uploadImage, uploadFormImage, isUploadingImage };
}

interface UploadImageRequest {
  file: File;
  description?: string;
}

type UploadImage = (image: UploadImageRequest) => Promise<ImageDto>;
type UploadFormImage = (image: FormImage) => Promise<ImageDto | undefined>;
